/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mobile_Upload_Error_CancelledInputs */

const en_mobile_upload_error_cancelled = /** @type {(inputs: Mobile_Upload_Error_CancelledInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Upload was cancelled.`)
};

const es_mobile_upload_error_cancelled = /** @type {(inputs: Mobile_Upload_Error_CancelledInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La subida fue cancelada.`)
};

/**
* | output |
* | --- |
* | "Upload was cancelled." |
*
* @param {Mobile_Upload_Error_CancelledInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const mobile_upload_error_cancelled = /** @type {((inputs?: Mobile_Upload_Error_CancelledInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mobile_Upload_Error_CancelledInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_mobile_upload_error_cancelled(inputs)
	return en_mobile_upload_error_cancelled(inputs)
});